export interface DragState {
  isDragging: boolean;
  startY: number;
  currentY: number;
}

export const createDragState = (): DragState => ({
  isDragging: false,
  startY: 0,
  currentY: 0,
});

export const startDrag = (clientY: number): DragState => ({
  isDragging: true,
  startY: clientY,
  currentY: clientY,
});

export const updateDrag = (state: DragState, clientY: number): DragState => {
  if (!state.isDragging) return state;

  const deltaY = clientY - state.startY;
  return {
    ...state,
    currentY: deltaY > 0 ? clientY : state.currentY,
  };
};

export const endDrag = (state: DragState, threshold: number = 100): { shouldClose: boolean; newState: DragState } => {
  if (!state.isDragging) return { shouldClose: false, newState: state };

  const deltaY = state.currentY - state.startY;
  const shouldClose = deltaY > threshold;

  return {
    shouldClose,
    newState: {
      isDragging: false,
      startY: 0,
      currentY: 0,
    },
  };
};

export const getDragTransform = (state: DragState): string => {
  if (!state.isDragging) return '';

  const deltaY = Math.max(0, state.currentY - state.startY);
  return `translateY(${deltaY}px)`;
};
